import PickUpDetail from './PickUpDetail';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { EmptyStatesForTab } from '../Tabs';
import { RECORDS_STATUS } from '../../../Constants';

const PickUp = React.forwardRef((props, ref) => {
  const user = useSelector((state) => state.userReducer.user);
  const loading = useSelector((state) => state.practicesReducer.loading);
  const [orders, setOrders] = useState([]);
  const [styles, setStyles] = useState(
    new Array(props.practiceOrdersData?.length).fill(false)
  );

  // This function sorts orders based on how urgent they are
  const sort_urgent_orders_first = (orders_array) => {
    return orders_array
      ?.slice()
      .sort(
        (a, b) => b.orders_count.urgent_orders - a.orders_count.urgent_orders
      );
  };

  // Event Handler
  const handleButton = (index) => {
    const updatedStyles = styles.map((element, id) =>
      id === index ? !element : false
    );
    setStyles(updatedStyles);
  };

  // This useEffect will take care of practice orders to display
  useEffect(() => {
    if (
      user.rider_route?.id === undefined &&
      props.currentValue === 'Assigned'
    ) {
      let sortedData = sort_urgent_orders_first(props.practiceOrdersData);
      setOrders(() => {
        return [...sortedData];
      });
    } else {
      setOrders(() => {
        return props.practiceOrdersData;
      });
    }
    // Setting Styles
    setStyles(new Array(props.practiceOrdersData?.length).fill(false));
  }, [props.practiceOrdersData, props.currentValue]);

  return (
    <Box>
      {!loading &&
      orders.length === 0 &&
      props.currentValue !== 'En-route' &&
      props.currentValue !== 'Assigned' ? (
        <EmptyStatesForTab
          title={RECORDS_STATUS[props.tabIndex]?.title}
          description={RECORDS_STATUS[props.tabIndex]?.description}
        />
      ) : (
        orders?.map((data, index) =>
          index === orders.length - 1 && ref !== null ? (
            <Box
              sx={{
                borderTop: '1px solid #DAE0EB',
                borderBottom: '1px solid #DAE0EB',
                padding: '8px 12px 4px',
                gap: '4px',
              }}
              key={index}
              ref={ref}
            >
              <PickUpDetail
                practice={data}
                distance={props.distance}
                locationCoordinates={props.locationCoordinates}
                index={index}
                currentValue={props.currentValue}
                urgentOrders={data.orders_count.urgent_orders}
                eOrders={data.orders_count.eorders}
                manualOrders={data.orders_count.manual_orders}
                handleButton={handleButton}
                dropDownHeight={props?.dropDownHeight}
                setDropDownHeight={props?.setDropDownHeight}
                style={styles[index]}
                enableWaze={
                  props.currentValue === 'En-route' && user?.enable_waze
                }
              />
            </Box>
          ) : (
            <Box
              sx={{
                borderTop: '1px solid #DAE0EB',
                padding: '8px 12px 4px',
                gap: '4px',
              }}
              key={index}
            >
              <PickUpDetail
                practice={data}
                distance={props.distance}
                locationCoordinates={props.locationCoordinates}
                index={index}
                currentValue={props.currentValue}
                urgentOrders={data.orders_count.urgent_orders}
                eOrders={data.orders_count.eorders}
                manualOrders={data.orders_count.manual_orders}
                handleButton={handleButton}
                dropDownHeight={props?.dropDownHeight}
                setDropDownHeight={props?.setDropDownHeight}
                style={styles[index]}
                enableWaze={
                  props.currentValue === 'En-route' && user?.enable_waze
                }
              />
            </Box>
          )
        )
      )}
      {props.currentValue !== 'En-route' && loading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            my: 'auto',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
});
PickUp.displayName = 'PickUp';
PickUp.propTypes = {
  practiceOrdersData: PropTypes.array.isRequired,
  current_value: PropTypes.string,
  currentValue: PropTypes.string.isRequired,
  dropDownHeight: PropTypes.bool.isRequired,
  setDropDownHeight: PropTypes.func.isRequired,
  locationCoordinates: PropTypes.object,
  distance: PropTypes.bool,
  tabIndex: PropTypes.number.isRequired,
};
export default PickUp;
